/* One ledger entry's page. Tokens only (ADR-0007). Hashes and identifiers are mono and wrap, never
   truncate: an auditor comparing two hashes needs every character. */

.kv {
  grid-template-columns: 130px minmax(0, 1fr);
}

.mono,
.id {
  font-family: var(--mono);
  font-size: var(--t-min);
  color: var(--ink-2);
  overflow-wrap: anywhere;
}

.aboutId {
  display: block;
  margin-top: 2px;
}

.ref {
  display: inline-flex;
  gap: 10px;
  align-items: baseline;
  flex-wrap: wrap;
}

.nav {
  display: inline-flex;
  gap: 14px;
  align-items: baseline;
  flex-wrap: wrap;
}

.linkState,
.commit {
  display: flex;
  gap: 8px;
  align-items: baseline;
  flex-wrap: wrap;
  margin: 10px 0 0;
  font-size: var(--t-min);
  color: var(--ink-2);
  line-height: 1.5;
}
